<template>
  <section v-if="entry">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div data-aos="fade-up" class="col-12 col-md-4 4 order-last order-md-first">
          <h2>{{ entry.title }}</h2>
          <prismic-rich-text class="awards" v-if="entry.awards" :field="entry.awards" />
          <prismic-rich-text :field="entry.description" />
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="600"
          v-if="entry && entry.img_realization.url"
          class="col-12 col-md-4 space-mobile"
        >
          <router-link
            :to="{
              name: 'public-interior-gallery',
              params: { slug: $route.params.slug, type: 'realizacja' },
            }"
          >
            <ReadMoreBtn title="Galeria realizacji" />
            <div
              class="gallery-entrance"
              :style="{ backgroundImage: `url(${entry.img_realization.url})` }"
            ></div>
          </router-link>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="600"
          v-if="entry && entry.img_visualization.url"
          class="col-12 col-md-4"
        >
          <router-link
            :to="{
              name: 'public-interior-gallery',
              params: { slug: $route.params.slug, type: 'wizualizacja' },
            }"
          >
            <ReadMoreBtn title="Galeria wizualizacji" />
            <div
              class="gallery-entrance"
              :style="{
                backgroundImage: `url(${entry.img_visualization.url})`,
              }"
            ></div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { useHead } from '@unhead/vue';
  import ReadMoreBtn from '../components/ReadMoreBtn';
  import { defaultMetaDescription } from '@/globals';

  export default {
    name: 'private-interior',
    setup() {
      useHead({
        title: 'Wnętrze publiczne - Marta Sergiej',
        meta: [
          {
            name: 'description',
            content: defaultMetaDescription,
          },
        ],
      });
    },
    components: {
      ReadMoreBtn,
    },
    watch: {
      $route() {
        this.getEntry();
      },
    },
    data() {
      return {
        entry: {
          img_realization: {
            url: null,
          },
          img_visualization: {
            url: null,
          },
        },
      };
    },
    methods: {
      getEntry() {
        this.$prismic.client
          .getByUID('public-project', this.$route.params.slug)
          .then((response) => {
            if (response) {
              this.entry = response.data;
            } else {
              this.$router.push({ name: 'public-interiors' });
            }
          });
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.getEntry();
      });
    },
  };
</script>

<style scoped lang="scss">
  @use '../AppVariables' as *;

  section {
    padding: calc($space / 4) 0;

    .gallery-entrance {
      width: 100%;
      margin-top: calc($space / 4);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      @media (min-width: 1940px) {
        width: 70%;
        height: calc(100vh - 410px);
      }

      @media (min-width: 768px) and (max-width: 1940px) {
        width: 80%;
        height: calc(100vh - 289px);
      }

      @media (max-width: 768px) {
        height: calc(100vh - 425px);
      }
    }

    .awards {
      font-weight: bold;
      margin-bottom: 25px;

      @media (min-width: 768px) {
        font-size: calc(0.6em + 0.2vw);
      }

      @media (max-width: 768px) {
        font-size: calc(0.8em + 0.2vw);
      }

      ::v-deep {
        a {
          opacity: 0.5;
          border-bottom: 1px solid $bgColor;
          transition-duration: $duration;

          &:hover {
            border-bottom: 1px solid;
            transition-duration: $duration;
          }
        }

        ul {
          padding: 20px;
          list-style: none;
          background-color: $bgColor;
          letter-spacing: 0.05vw;
        }
      }
    }
  }

  .space-mobile {
    @media (max-width: 768px) {
      margin-bottom: 50px;
    }
  }
</style>
